import { FURNITURE_TYPES } from '@easymoving/ui';
import he from '../../i18n/locales/he.json';
import en from '../../i18n/locales/en.json';
import ru from '../../i18n/locales/ru.json';
import fr from '../../i18n/locales/fr.json';
import ar from '../../i18n/locales/ar.json';

type Locale = { furniture: { type: Record<string, string> } };
const LOCALES = [he, en, ru, fr, ar] as unknown as Locale[];

/** key → all of its labels (he/en/ru/fr/ar) + the key, lowercased, for substring search. */
const TYPE_LABELS: Record<string, string[]> = Object.fromEntries(
  FURNITURE_TYPES.map((key) => {
    const labels = LOCALES.map((l) => l.furniture.type[key]).filter((s): s is string => !!s);
    return [key, [key.replace(/_/g, ' '), ...labels].map((s) => s.toLowerCase())];
  }),
);

/**
 * Furniture types whose label (in ANY of he/en/ru/fr/ar) — or key — contains the
 * query. Empty query → all types, in canonical group order. Pure.
 */
export function searchFurnitureTypes(query: string): string[] {
  const q = query.trim().toLowerCase();
  if (!q) return FURNITURE_TYPES;
  return FURNITURE_TYPES.filter((key) => TYPE_LABELS[key]!.some((label) => label.includes(q)));
}
